<template>
    <div>
        <!-- <div class="table-box">
            <div class="search-box">
                
            </div>
        </div> -->
        <Form inline>
        <FormItem label="">
            <Input placeholder="竞赛名称" style="width: 180px" v-model="searchName" />
        </FormItem>
        <FormItem label="">
            <DatePicker
                v-model="searchDate"
                type="date"
                value-type="YYYY-MM-DD"
                placeholder="选择发布时间范围"
                range
                format="YYYY-MM-DD"
                style="width:220px"
                confirm
        ></DatePicker>
        </FormItem>
        <FormItem label="">
            <Select
            style="width:150px;"
            placeholder="请选择竞赛状态"
            clearable
            v-model="searchStatus"
            >
                <Option value="3" >已发布</Option>
                <Option value="4" >比赛结束</Option>
                <Option value="5" >审阅结束</Option>
            </Select>
        </FormItem>
        <FormItem label="">
            <Select v-model="tags" style="width:200px" multiple placeholder="请选择竞赛标签">
                <Option :value="item.number" v-for="item in contestTypeList" >{{item.name}}</Option>
            </Select>
        </FormItem>
        <FormItem label="">
            <Button type="primary" style="margin-left: 10px" @click="getContest()">查询</Button>
        </FormItem>
    </Form>
    <Form inline>
        
        <Tag style="cursor:pointer"  v-model="sortNames.start_time" color="success" @click.native="orderClick('start_time')">时间<Icon :type="sortNames.start_time == '' ? 'md-arrow-round-up' : 'md-arrow-round-down' " /></Tag>
        <!-- <Tag style="cursor:pointer"  v-model="sortNames.proc_status" color="success" @click.native="orderClick('proc_status')">状态<Icon :type="sortNames.proc_status == '+' ? 'md-arrow-round-up' : 'md-arrow-round-down' " /></Tag> -->
    </Form>
        <div class="keywords-menu">
        <div>
            <List item-layout="vertical">
                <ListItem v-for="item in dataList.body" :key="item.name">
                    <router-link tag="a" class="recently_lou_plus_a" :to=" { name: 'detail-community', params: {'id': item.id} } ">
                        <ListItemMeta :title="item.name"/>
                    </router-link>
                    {{ item.remark }}
                    <template slot="action">
                        <li>
<!--                            <span>-->
<!--                                <img src="https://dev-file.iviewui.com/userinfoPDvn9gKWYihR24SpgC319vXY8qniCqj4/avatar" class="user-heading-img">-->
<!--                            </span>-->
                            {{item.create_user.name}}
                        </li>
                        <li v-if="item.tags">
                            <Tag color="blue" v-for="v in item.tags"  @click.native="searchTags(v.number)">{{v.name}}</Tag>
                        </li>
                        <li>开始时间：{{item.start_time}}</li>
                        <li>结束时间：{{item.end_time}}</li>
<!--                        <li>-->
<!--                            <Icon type="ios-chatbubbles-outline" /> 345-->
<!--                        </li>-->
                    </template>
                    <template slot="extra">
                        <span style="padding-right:10px;color: #298dff;">
                            <Tag :color="item.proc_status == 3 ? 'primary':(item.proc_status==4?'warning':'error') " size="large" >{{item.proc_status_name}}</Tag>
                            <!-- <img v-if="item.proc_status == 3 " src="../../../assets/contest/2.png" style="height: 50px;">
                            <img v-if="item.proc_status == 4 " src="../../../assets/contest/3.png" style="height: 50px;">
                            <img v-if="item.proc_status == 5 " src="../../../assets/contest/3.png" style="height: 50px;"> -->
                        </span>
                    </template>
                </ListItem>

                <Loading :spinShow="show"></Loading>
            </List>
            <div class="page-box">
                <Page
                        :total="dataList.page.count"
                        :page-size="dataList.page.page_size"
                        @on-change="changePage"
                        show-total
                />
            </div>
        </div>
    </div>
    </div>
</template>
<script>
    import Loading from "@/components/common_components/loading/loading_view";
    import {mapActions} from 'vuex'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/zh-cn';
    export default {
        name:"list",
        components:{
            Loading,
            DatePicker
        },
        data () {
            return {
                contestTypeList:[],
                searchName:'',
                searchStatus:'',
                tags:[],
                sort:'',
                orderIcons:[
                    "md-arrow-round-up",
                    "md-arrow-round-down"
                ],
                sortNames:{
                    // proc_status:"+",
                    start_time:"+",
                },
                searchDate:'',
                show:true,
                active_name:"all",
                page_num: 1,
                page_size: 24,
                dataList:{
                    body:[],
                    page:{
                        count:0,
                        page_num:0,
                        page_size:0
                    },
                },
            }
        },
        methods:{
            orderClick(name){
                switch(name){
                    case 'proc_status':
                        this.sortNames.proc_status = this.sortNames.proc_status == "" ? "-" : ""
                        break;
                    case 'start_time':
                        this.sortNames.start_time = this.sortNames.start_time == "" ? "-" : ""
                        break;
                }

                this.sort = this.sortNames.start_time+"start_time";

                this.getContest();
            },
            ...mapActions({
                getContestList:'contestCommunity/getContestList',
                getContestTypeList:'contestAdminCommunity/getContestTypeList',
            }),
            // 获取竞赛标签
            get_contest_type_list(){
                this.getContestTypeList({
                    callback:res=>{
                        this.contestTypeList = res;
                    },
                    error:msg=>{
                        this.$Message.error(msg);
                    }
                });
            },
            // menuChange(name){
            //     this.show = true;
            //     setTimeout(() =>{
            //         this.show = false;
            //         this.active_name = name
            //     },1000);
            // },
            searchTags(id){
                this.tags = [id];
                this.getContest();
            },
            getContest(){
                this.show = true;
                let _this = this;
                let data = {
                    page_num: _this.page_num,
                    page_size: _this.page_size,
                    name:_this.searchName,
                    tags:_this.tags.toString(),
                    proc_status:_this.searchStatus,
                    sort:_this.sort
                }

                if( this.searchDate != "" ){
                    data.start_time_begin = this.searchDate[0];
                    data.start_time_end = this.searchDate[1];
                }


                this.getContestList({
                    data:data,
                    callback:res=>{
                        _this.dataList = res;
                        _this.show = false;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                        _this.show = false;
                    }
                }).catch(err=>{
                    _this.show = false;
                })
            },
            changePage(page){
                this.page_num = page;
                this.getContest()
            }
        },
        mounted() {
            this.getContest();
            this.get_contest_type_list();
        }
    }
</script>
<style scoped lang="less">
    @import "../../../assets/style/index";
</style>
<style scoped>
    .user-heading-img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        position: relative;
        margin-right: 6px;
    }
    .ivu-list-item-meta-title{
        font-weight: 600;
    }
</style>